import React, { useState } from "react";
import { CicdFaqs } from "../../../components/faqData.js";
import ContactUs from "../../../components/ContactUs.js";
import { Helmet } from "react-helmet-async";

const AwsSolutions = () => {
  const [actIndex, setActIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActIndex(index === actIndex ? null : index);
  };
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  const awsOfferings = [
    {
      logo_images:"../assets/icons/aws-solution/service-1.png",
      title: "EC2 Compute",
      description:
        "Deploy scalable virtual servers with Amazon EC2, offering flexible instance types, auto-scaling capabilities, and pay-as-you-go pricing for optimal cost efficiency.",
    },
    {
      logo_images:"../assets/icons/aws-solution/service-2.png",
      title: "S3 Storage",
      description:
        "Leverage Amazon S3 for secure, durable, and highly scalable object storage with industry-leading availability and data protection features.",
    },
    {
      logo_images:"../assets/icons/aws-solution/service-3.png",
      title: "VPC & Networking",
      description:
        "Build isolated, secure cloud networks with Amazon VPC, enabling complete control over network topology, IP addressing, and security groups.",
    },
    {
      logo_images:"../assets/icons/aws-solution/service-4.png",
      title: "IAM & Security",
      description:
        "Implement robust identity and access management with AWS IAM, ensuring fine-grained permissions, multi-factor authentication, and compliance-ready security controls.",
    },
    {
      logo_images:"../assets/icons/aws-solution/service-5.png",
      title: "RDS & Databases",
      description:
        "Deploy managed relational databases with Amazon RDS, supporting MySQL, PostgreSQL, Oracle, and SQL Server with automated backups and high availability.",
    },
    {
      logo_images:"../assets/icons/aws-solution/service-6.png",
      title: "Lambda / Serverless",
      description:
        "Build event-driven, serverless applications with AWS Lambda, eliminating infrastructure management while scaling automatically with usage.",
    },
    {
      logo_images:"../assets/icons/aws-solution/service-7.png",
      title: "CloudFront CDN",
      description:
        "Accelerate content delivery globally with Amazon CloudFront, reducing latency and improving user experience with edge locations worldwide.",
    },
    {
      logo_images:"../assets/icons/aws-solution/service-8.png",
      title: "Load Balancers / Auto Scaling",
      description:
        "Ensure high availability and fault tolerance with Elastic Load Balancing and Auto Scaling, automatically distributing traffic and adjusting capacity.",
    },
  ];

  const benefits = [
    "Scalability and elasticity to handle variable workloads",
    "Cost optimization with pay-as-you-go pricing models",
    "Global infrastructure with 99.99% uptime SLA",
    "Enterprise-grade security and compliance certifications",
    "Comprehensive suite of 200+ cloud services",
    "24/7 monitoring and automated disaster recovery",
  ];

  const expertise = [
    "AWS Certified Solutions Architects and DevOps Engineers",
    "Multi-region deployment and disaster recovery strategies",
    "Cost optimization and reserved instance planning",
    "Security hardening and compliance (SOC 2, HIPAA, GDPR)",
    "Container orchestration with ECS and EKS",
    "Serverless architecture design and implementation",
    "CI/CD pipeline integration with CodePipeline and CodeDeploy",
    "Infrastructure as Code using CloudFormation and Terraform",
  ];

  const useCases = [
    {
      title: "Enterprise Cloud Migration",
      description:
        "Migrated legacy on-premises infrastructure to AWS, reducing operational costs by 40% while improving scalability and disaster recovery capabilities.",
    },
    {
      title: "High-Traffic Web Application",
      description:
        "Designed and deployed a serverless architecture using Lambda, API Gateway, and DynamoDB, handling millions of requests with auto-scaling and minimal infrastructure overhead.",
    },
    {
      title: "Multi-Region Disaster Recovery",
      description:
        "Implemented a comprehensive DR strategy with RDS Multi-AZ, automated backups, and cross-region replication, achieving 99.99% availability.",
    },
    {
      title: "DevOps Automation Platform",
      description:
        "Built CI/CD pipelines with CodePipeline, CodeBuild, and CodeDeploy, reducing deployment time from hours to minutes with automated testing and rollback capabilities.",
    },
  ];

  const whyChooseUs = [
    "13+ years of AWS cloud engineering experience",
    "Certified AWS partners with proven migration track record",
    "End-to-end services from architecture design to managed operations",
    "Cost optimization strategies that reduce cloud spend by 30-50%",
    "24/7 monitoring and proactive incident management",
    "Security-first approach with compliance-ready implementations",
  ];

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Maximize your business efficiency and reduce costs with India’s best AWS consulting services. Expert cloud solutions for secure, scalable, and optimized infrastructure."
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="Boost Efficiency & Cut Costs with Best AWS Consulting Services in India | Ayanshtech Solutions"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="http://ayanshtechnology.com/devops-aws"
        />
        <meta
          property="og:description"
          content="Maximize your business efficiency and reduce costs with India’s best AWS consulting services. Expert cloud solutions for secure, scalable, and optimized infrastructure."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="http://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="Boost Efficiency & Cut Costs with Best AWS Consulting Services in India | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="Maximize your business efficiency and reduce costs with India’s best AWS consulting services. Expert cloud solutions for secure, scalable, and optimized infrastructure."
        />
        <meta
          name="twitter:image"
          content="http://ayanshtechnology.com/assets/logo.png"
        />

        <link
          rel="canonical"
          href="http://ayanshtechnology.com/devops-aws"
        />
        <title>
          Boost Efficiency & Cut Costs with Best AWS Consulting Services in India | Ayanshtech Solutions
        </title>
      </Helmet>
      <div className="flex flex-col items-center justify-center mb-6 p-6">
        {/* Hero Section */}
        <div className="py-5 w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
            <div className="lg:w-3/4 lg:text-left p-4">
              <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                AWS Solutions for Scalable Cloud Infrastructure
              </h1>

              <p className="sm:text-base md:text-lg lg:text-lg mb-3">
                Transform your business with Amazon Web Services (AWS), the
                world's most comprehensive and widely adopted cloud platform.
                Ayanshtech Solutions delivers end-to-end <a
    className="relative 
    before:content-[''] before:absolute before:left-1/2 before:-bottom-1 
    before:h-[2px] before:w-0 before:bg-green-600 
    before:transition-all before:duration-300 
    hover:before:left-0 hover:before:w-full text-green-600 font-bold"
    href="https://ayanshtechnology.com/hire-aws-migration-engineers"
  >
AWS consulting
  </a>,
                migration, and managed services to help you leverage the full
                power of cloud computing.
              </p>

              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                Our AWS-certified experts design, deploy, and optimize cloud
                architectures that scale with your business needs. From EC2
                compute and S3 storage to serverless Lambda functions and
                advanced networking, we help you build secure, cost-effective,
                and high-performance cloud solutions.
              </p>

              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                Whether you're migrating legacy systems, building cloud-native
                applications, or optimizing existing AWS infrastructure, our team
                ensures seamless implementation with best practices, security
                compliance, and cost optimization at the core of every
                solution.
              </p>

              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold py-2 px-4 rounded-full mt-6"
              >
                Get Started
              </button>
            </div>

            <div className="flex w-full md:w-1/2  justify-center mb-12 lg:mb-0">
              <img
                src="../assets/images/devops-pages/aws-banner.png"
                alt="AWS Cloud Solutions"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>

        {/* About AWS Cloud Services */}
        {/* <div className="mb-5 mt-10 p-4">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            About AWS Cloud Services
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Amazon Web Services (AWS) provides a robust, scalable, and secure
            cloud computing platform trusted by millions of businesses
            worldwide. With over 200 fully featured services spanning compute,
            storage, databases, networking, analytics, machine learning, and
            more, AWS enables organizations to innovate faster, reduce costs, and
            scale globally.
          </p>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            At Ayanshtech, we specialize in helping businesses harness AWS's
            capabilities to modernize infrastructure, accelerate digital
            transformation, and achieve operational excellence. Our
            comprehensive AWS services cover everything from initial strategy
            and migration to ongoing optimization and managed operations.
          </p>
        </div> */}

        {/* AWS Offerings */}
        <div className="text-center mb-5 mt-12">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Comprehensive AWS Offerings
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Explore our extensive range of <a
    className="relative 
    before:content-[''] before:absolute before:left-1/2 before:-bottom-1 
    before:h-[2px] before:w-0 before:bg-green-600 
    before:transition-all before:duration-300 
    hover:before:left-0 hover:before:w-full text-green-600 font-bold"
    href="https://ayanshtechnology.com/hire-aws-migration-engineers"
  >
   AWS services
  </a> designed to meet your
            infrastructure, application, and business requirements.
          </p>
        </div>

        <div className="rounded-3xl">
          <div className="p-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
              {awsOfferings.map((offering, index) => (
                <div
                  key={index}
                  className="relative flex flex-col space-y-4 rounded-3xl shadow-md p-6 border border-gray-100
        transition-all duration-300 ease-out transform-gpu
        hover:scale-105 hover:shadow-1xl
        hover:bg-gradient-to-l hover:from-blue-300 hover:to-green-200 hover:border-none"
                  // style={{
                  //   boxShadow:
                  //     "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                  // }}
                >
                  <div className="flex items-center gap-2">
                    <div className="w-[60px] h-[60px]  ">
                      <img src={offering.logo_images} className="w-full rounded-2xl" alt="" />
                    </div>
                  <h3 className="text-lg font-bold">{offering.title}</h3>
                  </div>
                  <p className="text-lg">{offering.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Benefits of AWS */}
        <div className="text-center mb-5 mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Benefits of AWS for Businesses
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Discover how AWS cloud services can transform your business
            operations, reduce costs, and accelerate innovation.
          </p>
        </div>

        <div className="p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 rounded-3xl shadow-md p-6 border border-gray-100
        transition-all duration-300 ease-out transform-gpu
        hover:scale-105 hover:shadow-1xl
        hover:bg-gradient-to-l hover:from-blue-300 hover:to-green-200 hover:border-none"
              >
                <div className="h-3 w-3 rounded-full bg-blue-600 mt-2 flex-shrink-0" />
                <p className="text-lg text-gray-700">{benefit}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Our Expertise in AWS */}
        <div className="p-6 sm:p-4 md:p-6 lg:p-2 w-full rounded-3xl mt-10">
          <div className="text-center mb-8">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Our Expertise in AWS
            </h2>
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              Ayanshtech's AWS-certified team brings deep expertise across the
              entire AWS ecosystem, delivering solutions that align with your
              business objectives and technical requirements.
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-center mb-8">
            <ul className="list-disc pl-8 sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto space-y-3">
              {expertise.map((item, index) => (
                <li key={index} className="text-gray-700">
                  {item}
                </li>
              ))}
            </ul>
            <div className="w-full md:w-1/2 sm:m-10">
              <img src="../assets/images/devops-pages/aws-image.webp" className="w-full h-auto" alt="" />
            </div>
          </div>
        </div>

        {/* Real-world Use Cases */}
        <div className="text-center mb-5 mt-10">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Real-World Use Cases
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            See how we've helped businesses achieve their cloud transformation
            goals with AWS solutions.
          </p>
        </div>

        <div className="rounded-3xl">
          <div className="p-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8">
              {useCases.map((useCase, index) => (
                <div
                  key={index}
                  className="relative flex flex-col space-y-4 rounded-3xl shadow-md p-6 border border-gray-100
        transition-all duration-300 ease-out transform-gpu
        hover:scale-105 hover:shadow-1xl
        hover:bg-gradient-to-l hover:from-blue-300 hover:to-green-200 hover:border-none"
                 
                >
                  <h3 className="text-lg font-bold">{useCase.title}</h3>
                  <p className="text-lg">{useCase.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="p-6 sm:p-8 md:p-12 lg:p-16 w-full rounded-3xl mt-10">
          <div className="text-center mb-8">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Why Choose Ayanshtech for AWS Solutions
            </h2>
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              Partner with Ayanshtech for AWS expertise that drives measurable
              business outcomes. Our proven methodology, certified engineers, and
              customer-first approach ensure successful cloud transformations.
            </p>
          </div>

          <div className="mb-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-7xl mx-auto">
              {whyChooseUs.map((reason, index) => (
                <div
                  key={index}
                  className="flex items-start space-x-4 rounded-2xl shadow-md p-6 border border-gray-100
        transition-all duration-300 ease-out transform-gpu
        hover:scale-105 hover:shadow-1xl
        hover:bg-gradient-to-l hover:from-blue-300 hover:to-green-200 hover:border-none"
                >
                  <div className="h-3 w-3 rounded-full bg-green-600 mt-2 flex-shrink-0" />
                  <p className="text-lg text-gray-700">{reason}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center">
            <button
              onClick={scrollToContact}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-full text-lg transition duration-300"
            >
              Schedule a Free AWS Consultation Today!
            </button>
          </div>
        </div>

        {/* FAQs */}
        <div className="max-w-3xl mx-auto p-6 py-20 w-full">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
            FAQs
          </h2>
          {CicdFaqs.map((faq, index) => (
            <div key={index} className="border-b">
              <button
                onClick={() => toggleFAQ(index)}
                className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                  actIndex === index
                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                    : ""
                }`}
              >
                <span className="text-lg">{faq.question}</span>
                <span className="text-2xl">
                  {actIndex === index ? "-" : "+"}
                </span>
              </button>
              {actIndex === index && (
                <div className="p-4 text-gray-700">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>

        {/* Contact Section */}
        <div id="contact-section">
          <ContactUs />
        </div>
      </div>
    </>
  );
};

export default AwsSolutions;

